@let listConfig = config();

<div class="container w-full max-w-none">
  <div
    class="list-actions mb-4 lg:mb-4 sm:mb-6"
    [class.hidden-search]="listConfig.hideSearch"
    [class.hidden-filter]="listConfig.hideFilterSection"
  >
    @if (!listConfig.hideSearch) {
      <korviu-input
        label="{{ 'korviuList.search' | translate }}"
        class="list-actions-search"
        [control]="searchControl"
        [prefixIconType]="'search'"
        [applyCustomStyle]="true"
      ></korviu-input>
    }
    <korviu-select
      [ngClass]="{ 'selected-option': sortControl.value }"
      label="{{ ('korviuList.sort' | translate) + (sorting ? ' (1)' : '') }}"
      [prefixType]="'sort'"
      [customDropdown]="true"
      [disable]="!sortSectionsView.length"
      #sortSelect
      class="list-actions-sort"
    >
      <div>
        <nz-radio-group [formControl]="sortControl">
          <nz-collapse nzGhost>
            @for (
              sortSection of sortSectionsView;
              track sortSection.localizableName ?? sortSection.name ?? sortSection.options[0]?.nzValue
            ) {
              <nz-collapse-panel
                nzHeader="{{
                  sortSection.localizableName ? (sortSection.localizableName | translate) : sortSection.name
                }}"
                [nzActive]="true"
              >
                @for (option of sortSection.options; track option.nzValue) {
                  <label nz-radio [nzValue]="option.nzValue">
                    {{ option.localizableName ? (option.localizableName | translate) : option.name }}
                  </label>
                }
              </nz-collapse-panel>
            }
          </nz-collapse>
        </nz-radio-group>
      </div>
    </korviu-select>
    @if (!listConfig.hideFilterSection) {
      <korviu-select
        [ngClass]="{ 'selected-option': filters.length > 0 }"
        label="
          {{ ('korviuList.filter' | translate) + (!!filters.length ? ' (' + filters.length + ')' : '') }}
        "
        class="list-actions-filter"
        [disable]="filterSectionsIsLoading || !filterSectionsView.length"
        [prefixType]="'filter'"
        [customDropdown]="true"
        #filterSelect
      >
        <div class="filter-dropdown">
          <nz-collapse nzGhost>
            @for (filterSection of filterSectionsView; track filterSection.parameter_name) {
              <nz-collapse-panel
                nzHeader="{{
                  filterSection.localizableName ? (filterSection.localizableName | translate) : filterSection.name
                }}"
                [nzActive]="true"
              >
                @for (checkboxModel of filterSection.checkboxModel; track checkboxModel.parameter_name) {
                  <label
                    nz-checkbox
                    [nzValue]="checkboxModel.value"
                    [(nzChecked)]="checkboxModel.checked"
                    (nzCheckedChange)="onFilterChange(filterSection, checkboxModel, $event)"
                  >
                    {{
                      checkboxModel.localizableName ? (checkboxModel.localizableName | translate) : checkboxModel.label
                    }}
                  </label>
                }
              </nz-collapse-panel>
            }
          </nz-collapse>
        </div>
      </korviu-select>
    }
  </div>
  @if (listConfig.enableBulkRemoval && !isLoading && !loadError() && items.length) {
    <div class="bulk-selection-actions mb-4">
      <button type="button" (click)="hasSelectedReferrals ? onUnselectAllReferrals() : onSelectAllReferrals()">
        {{ (hasSelectedReferrals ? 'common.unselectAll' : 'common.selectAll') | translate }}
      </button>
      @if (hasSelectedReferrals) {
        <span>-</span>
        <button type="button" (click)="onRemoveSelectedReferrals()">
          {{ 'buildYourNetwork.removeReferrals' | translate }}
        </button>
      }
    </div>
  }
  @if (!loadError()) {
    <div class="total-info mb-4">
      <span>
        {{ total }}
        {{ totalLabel }}
      </span>
      <span>{{ itemRange }} {{ 'common.of' | translate }} {{ total }}</span>
    </div>
  }
  @if (listFiltersTplRef()) {
    <ng-container [ngTemplateOutlet]="listFiltersTplRef()"></ng-container>
  }
  <div class="selected-items mb-2">
    @if (selectedSorting.length || selectedFilters.length) {
      <div class="selected-filters-chips mb-4">
        @for (sort of selectedSorting; track sort.key; let i = $index) {
          <nz-tag class="selected-filters-chips-item">
            <span>
              {{ sort.isNameLocalizable ? (sort.name | translate) : sort.name }}:
              {{ sort.isValueLocalizable ? (sort.value | translate) : sort.value }}
            </span>
            <button nz-button nzType="text" (click)="onDeleteSelectedFilterOrSorting(i, true)">
              <i nz-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M10.0013 1.66797C14.6036 1.66797 18.3346 5.39893 18.3346 10.0013C18.3346 14.6036 14.6036 18.3346 10.0013 18.3346C5.39893 18.3346 1.66797 14.6036 1.66797 10.0013C1.66797 5.39893 5.39893 1.66797 10.0013 1.66797ZM12.9432 7.05936L12.8731 6.99884C12.6556 6.83747 12.3571 6.83548 12.1376 6.99287L12.0594 7.05936L10.0013 9.11714L7.94324 7.05936L7.87314 6.99884C7.65565 6.83747 7.35714 6.83548 7.13765 6.99287L7.05936 7.05936L6.99884 7.12946C6.83747 7.34695 6.83548 7.64546 6.99287 7.86495L7.05936 7.94324L9.11714 10.0013L7.05936 12.0594L6.99884 12.1295C6.83747 12.347 6.83548 12.6455 6.99287 12.865L7.05936 12.9432L7.12946 13.0037C7.34695 13.1651 7.64546 13.1671 7.86495 13.0097L7.94324 12.9432L10.0013 10.8855L12.0594 12.9432L12.1295 13.0037C12.347 13.1651 12.6455 13.1671 12.865 13.0097L12.9432 12.9432L13.0037 12.8731C13.1651 12.6556 13.1671 12.3571 13.0097 12.1376L12.9432 12.0594L10.8855 10.0013L12.9432 7.94324L13.0037 7.87314C13.1651 7.65565 13.1671 7.35714 13.0097 7.13765L12.9432 7.05936Z"
                    fill="#8A8E94"
                  />
                </svg>
              </i>
            </button>
          </nz-tag>
        }
        @for (filter of selectedFilters; track filter.key; let i = $index) {
          <nz-tag class="selected-filters-chips-item">
            <span>{{ filter.isLocalizable ? (filter.label | translate) : filter.label }}</span>
            <button nz-button nzType="text" (click)="onDeleteSelectedFilterOrSorting(i)">
              <i nz-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M10.0013 1.66797C14.6036 1.66797 18.3346 5.39893 18.3346 10.0013C18.3346 14.6036 14.6036 18.3346 10.0013 18.3346C5.39893 18.3346 1.66797 14.6036 1.66797 10.0013C1.66797 5.39893 5.39893 1.66797 10.0013 1.66797ZM12.9432 7.05936L12.8731 6.99884C12.6556 6.83747 12.3571 6.83548 12.1376 6.99287L12.0594 7.05936L10.0013 9.11714L7.94324 7.05936L7.87314 6.99884C7.65565 6.83747 7.35714 6.83548 7.13765 6.99287L7.05936 7.05936L6.99884 7.12946C6.83747 7.34695 6.83548 7.64546 6.99287 7.86495L7.05936 7.94324L9.11714 10.0013L7.05936 12.0594L6.99884 12.1295C6.83747 12.347 6.83548 12.6455 6.99287 12.865L7.05936 12.9432L7.12946 13.0037C7.34695 13.1651 7.64546 13.1671 7.86495 13.0097L7.94324 12.9432L10.0013 10.8855L12.0594 12.9432L12.1295 13.0037C12.347 13.1651 12.6455 13.1671 12.865 13.0097L12.9432 12.9432L13.0037 12.8731C13.1651 12.6556 13.1671 12.3571 13.0097 12.1376L12.9432 12.0594L10.8855 10.0013L12.9432 7.94324L13.0037 7.87314C13.1651 7.65565 13.1671 7.35714 13.0097 7.13765L12.9432 7.05936Z"
                    fill="#8A8E94"
                  />
                </svg>
              </i>
            </button>
          </nz-tag>
        }
      </div>
    }
  </div>
  <div class="list-buttons">
    @if (listConfig.createFn) {
      <korviu-button icon="plus" (click)="listConfig.createFn()">
        {{ listConfig.createLabelLocalizable | translate }}
      </korviu-button>
    }
  </div>
  @if (listConfig.itemType === KorviuListItemTypes.PRODUCT) {
    <app-redeemable-in-filter (redeemableInChange)="listConfig.redeemableChangeFn($event)" class="w-full block" />
  }
  <div
    #listViewport
    class="list-content w-full flex flex-col items-center"
    [class.scroll-pagination]="listConfig.scrollPagination"
    [attr.tabindex]="listConfig.scrollPagination ? 0 : null"
    [attr.aria-label]="listConfig.scrollPagination ? (listConfig.totalLocalizableName | translate) : null"
    [attr.aria-busy]="isLoading || loadingMore()"
    (scroll)="onListScroll()"
  >
    <div class="item-list">
      @if (isLoading) {
        @for (skeletonItem of skeletonItems; track skeletonItem) {
          <div>
            <nz-skeleton [nzAvatar]="true" [nzParagraph]="{ rows: 1 }"></nz-skeleton>
          </div>
        }
      } @else if (loadError(); as error) {
        <div class="flex flex-col items-center gap-6 py-8 text-center md:gap-8" role="alert">
          <p class="list-state-message m-0 max-w-[28rem] text-[0.8125rem]/[1.6] md:text-[0.9375rem]">
            {{ (error === 'timeout' ? 'korviuList.loadTimeout' : 'korviuList.loadError') | translate }}
          </p>
          <korviu-button
            class="[--button__border-radius:0.375rem] [--button__height:2rem] md:[--button__height:2.5rem]"
            color="tertiary"
            size="small"
            (onclick)="reloadData()"
          >
            {{ 'korviuList.retry' | translate }}
          </korviu-button>
        </div>
      } @else if (items?.length) {
        @switch (listConfig.itemType) {
          @case (KorviuListItemTypes.PRODUCT) {
            <product-list
              [products]="items"
              (toggleFavorite)="listConfig.toggleFavoriteFn($event)"
              (productClick)="onDetailsClick($event)"
            />
          }
          @case (KorviuListItemTypes.TRANSACTION) {
            <transaction-list
              class="mb-6 md:mb-4 lg:mb-4"
              [transactions]="items"
              [highlightedItem]="listConfig.highlightedItem"
              [detailsEnabled]="!!listConfig.detailsFn"
              (recordClick)="onDetailsClick($event)"
            />
          }
          @case (KorviuListItemTypes.GANARBOL) {
            <ganarbol-list [ganarbols]="items" (ganarbolClick)="onDetailsClick($event)" />
          }
          @case (KorviuListItemTypes.GANAMIGOSNETWORK) {
            <my-ganamigos-network-list
              [ganamigosNetwork]="items"
              (ganamigosClick)="onDetailsClick($event)"
              (sendMessage)="listConfig.customFunctions?.get('sendMessage')($event)"
              (shareGanas)="listConfig.customFunctions?.get('shareGanas')($event)"
            />
          }
          @case (KorviuListItemTypes.REFERRAL) {
            <referral-list
              [referrals]="items"
              [selectionEnabled]="!!listConfig.enableBulkRemoval"
              [selectedReferralIds]="selectedReferralIds"
              (referralClick)="onDetailsClick($event)"
              (selectedReferralIdsChange)="onSelectedReferralIdsChange($event)"
            />
          }
          @case (KorviuListItemTypes.REFERRAL_GANASOCIOS) {
            <app-referral-list-ganasocios
              [items]="items"
              [selectionEnabled]="!!listConfig.enableBulkRemoval"
              [selectedReferralIds]="selectedReferralIds"
              (referralClick)="onDetailsClick($event)"
              (selectedReferralIdsChange)="onSelectedReferralIdsChange($event)"
            />
          }
          @case (KorviuListItemTypes.BRAND) {
            <brand-list [brands]="items" (brandClick)="onDetailsClick($event)" />
          }
          @case (KorviuListItemTypes.MY_SPECIAL_FOREST) {
            <app-my-special-forest
              [forestMembers]="items"
              [pageOffset]="(pagination.page - 1) * pagination.pageSize"
              (membersClick)="onDetailsClick($event)"
            />
          }
          @case (KorviuListItemTypes.SPECIAL_PAYMENTS) {
            <app-special-payments [specialPayments]="items" />
          }
          @case (KorviuListItemTypes.TOTAL_CONTRIBUTION) {
            <app-total-contribution-list [list]="items" (userClick)="onDetailsClick($event)" />
          }
          @case (KorviuListItemTypes.MY_FOREST) {
            <app-my-forest-list [list]="items" (userClick)="onDetailsClick($event)" />
          }
          @case (KorviuListItemTypes.MY_FOREST_SPECIAL) {
            <app-my-forest-list-special [list]="items" (userClick)="onDetailsClick($event)" />
          }
          @case (KorviuListItemTypes.RECENT_ACTIVITY) {
            <app-recent-activity [items]="items" (activityClick)="onDetailsClick($event)" />
          }
          @case (KorviuListItemTypes.PRODUCT_LIST) {
            <app-product-list-v2 [items]="items" />
          }
        }
      } @else {
        <ng-container [ngTemplateOutlet]="noData"></ng-container>
      }
    </div>
    @if (loadingMore()) {
      <nz-skeleton class="w-full" [nzParagraph]="{ rows: 1 }" [nzActive]="true" />
    } @else if (loadMoreError()) {
      <div class="flex flex-col items-center gap-4 py-6" role="alert">
        <p>{{ 'korviuList.loadError' | translate }}</p>
        <korviu-button color="tertiary" size="small" (onclick)="loadMore()">{{
          'korviuList.retry' | translate
        }}</korviu-button>
      </div>
    }
    @if (!listConfig.scrollPagination && !isLoading && !loadError() && !isSinglePage) {
      <nz-pagination
        [nzPageIndex]="pagination.page"
        [nzPageSize]="pagination.pageSize"
        [nzTotal]="total"
        [nzHideOnSinglePage]="true"
        [nzSize]="'small'"
        [class.prev-disabled]="pagination.page === 1"
        [class.next-disabled]="pagination.page === totalPages"
        (nzPageIndexChange)="onEventsListPageIndexChange($event)"
        class="pagination mt-10 md:mt-12"
      ></nz-pagination>
    }
  </div>
</div>

<ng-template #noData>
  @if (emptyTpl()) {
    <ng-container [ngTemplateOutlet]="emptyTplRef()"></ng-container>
  } @else {
    <korviu-no-data></korviu-no-data>
  }
</ng-template>
